import axios from 'axios';

// Create axios instance for onboarding API (no auth required)
const onboardingApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/onboarding`,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const register = async (data) => {
  const response = await onboardingApi.post('/register', data);
  return response.data;
};

export const checkSlug = async (slug) => {
  const response = await onboardingApi.get(`/check-slug/${slug}`);
  return response.data;
};

export const validateCedula = async (identificacion) => {
  const response = await onboardingApi.post('/validate-cedula', { identificacion });
  return response.data;
};

export default {
  register,
  checkSlug,
  validateCedula
};
